import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";
import { SettingsTabRedirect } from "../settings-tab-redirect";
import { inventorySettingsRoutes as originalRoutes } from "./inventory";

const legacySections: Record<string, string> = {
  "inventory-management/general": "general",
  "inventory-management/purchase-orders": "purchase-orders",
  "inventory-management/quickbooks": "accounting",
};

export const inventorySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Inventory management");
      },
      permission: settingsPagePermission(
        "inventory-management/inventory-management",
      ),
    },
    path: "inventory-management",
    lazy: async () => {
      const { InventoryManagementSettingsPage } =
        await import("../../../../setting/inventory-management/inventory-management-settings");
      return { Component: InventoryManagementSettingsPage };
    },
  },
  ...originalRoutes.map((route): PermissionedRouteObject => {
    const { lazy: _lazy, ...base } = route;
    const section = route.path && legacySections[route.path];
    if (!section) {
      return route;
    }
    const redirect = (
      <SettingsTabRedirect
        from={`/settings/${route.path}`}
        section={section}
        to="/settings/inventory-management"
      />
    );
    return route.children
      ? {
          ...base,
          index: false,
          children: [
            { index: true, element: redirect },
            ...route.children.filter((child) => !child.index),
          ],
        }
      : { ...base, element: redirect };
  }),
];
